var map = {
	"./Babylonian.sol/Babylonian.dbg.json": 1526,
	"./Babylonian.sol/Babylonian.json": 1527,
	"./DiscoLP.sol/$.dbg.json": 1528,
	"./DiscoLP.sol/$.json": 1529,
	"./DiscoLP.sol/DiscoLP.dbg.json": 1530,
	"./DiscoLP.sol/DiscoLP.json": 1531,
	"./DiscoLP.sol/Pair.dbg.json": 1532,
	"./DiscoLP.sol/Pair.json": 1533,
	"./DiscoLP.sol/PoolToken.dbg.json": 1534,
	"./DiscoLP.sol/PoolToken.json": 1535,
	"./DiscoLP.sol/Router01.dbg.json": 1536,
	"./DiscoLP.sol/Router01.json": 1537,
	"./DiscoLP.sol/Router02.dbg.json": 1538,
	"./DiscoLP.sol/Router02.json": 1539,
	"./DiscoLP.sol/UniswapV2LiquidityPoolAbstraction.dbg.json": 1540,
	"./DiscoLP.sol/UniswapV2LiquidityPoolAbstraction.json": 1541,
	"./DiscoLPFactory.sol/DiscoLPFactory.dbg.json": 1542,
	"./DiscoLPFactory.sol/DiscoLPFactory.json": 1543,
	"./DiscoLPFactory.sol/IUniswapV2Factory.dbg.json": 1544,
	"./DiscoLPFactory.sol/IUniswapV2Factory.json": 1545,
	"./DiscoLPFactory.sol/Token.dbg.json": 1546,
	"./DiscoLPFactory.sol/Token.json": 1547,
	"./Dummy.sol/Dummy.dbg.json": 1548,
	"./Dummy.sol/Dummy.json": 1549,
	"./DummyLevel.sol/DummyLevel.dbg.json": 1550,
	"./DummyLevel.sol/DummyLevel.json": 1551,
	"./FakerDAO.sol/$.dbg.json": 1552,
	"./FakerDAO.sol/$.json": 1553,
	"./FakerDAO.sol/FakerDAO.dbg.json": 1554,
	"./FakerDAO.sol/FakerDAO.json": 1555,
	"./FakerDAO.sol/Pair.dbg.json": 1556,
	"./FakerDAO.sol/Pair.json": 1557,
	"./FakerDAO.sol/PoolToken.dbg.json": 1558,
	"./FakerDAO.sol/PoolToken.json": 1559,
	"./FakerDAOFactory.sol/FakerDAOFactory.dbg.json": 1560,
	"./FakerDAOFactory.sol/FakerDAOFactory.json": 1561,
	"./FakerDAOFactory.sol/IUniswapV2Factory.dbg.json": 1562,
	"./FakerDAOFactory.sol/IUniswapV2Factory.json": 1563,
	"./FakerDAOFactory.sol/Router01.dbg.json": 1564,
	"./FakerDAOFactory.sol/Router01.json": 1565,
	"./FakerDAOFactory.sol/Router02.dbg.json": 1566,
	"./FakerDAOFactory.sol/Router02.json": 1567,
	"./FakerDAOFactory.sol/Token.dbg.json": 1568,
	"./FakerDAOFactory.sol/Token.json": 1569,
	"./Instance.sol/Instance.dbg.json": 1570,
	"./Instance.sol/Instance.json": 1571,
	"./InstanceFactory.sol/InstanceFactory.dbg.json": 1572,
	"./InstanceFactory.sol/InstanceFactory.json": 1573,
	"./MainChef.sol/KhinkalToken.dbg.json": 1574,
	"./MainChef.sol/KhinkalToken.json": 1575,
	"./MainChef.sol/LPToken.dbg.json": 1576,
	"./MainChef.sol/LPToken.json": 1577,
	"./MainChef.sol/MainChef.dbg.json": 1578,
	"./MainChef.sol/MainChef.json": 1579,
	"./MainChefFactory.sol/MainChefFactory.dbg.json": 1580,
	"./MainChefFactory.sol/MainChefFactory.json": 1581,
	"./MayTheForceBeWithYou.sol/MayTheForceBeWithYou.dbg.json": 1582,
	"./MayTheForceBeWithYou.sol/MayTheForceBeWithYou.json": 1583,
	"./MayTheForceBeWithYou.sol/MiniMeToken.dbg.json": 1584,
	"./MayTheForceBeWithYou.sol/MiniMeToken.json": 1585,
	"./MayTheForceBeWithYouFactory.sol/MayTheForceBeWithYouFactory.dbg.json": 1586,
	"./MayTheForceBeWithYouFactory.sol/MayTheForceBeWithYouFactory.json": 1587,
	"./P2PSwapper.sol/IP2P_WETH.dbg.json": 1588,
	"./P2PSwapper.sol/IP2P_WETH.json": 1589,
	"./P2PSwapper.sol/P2PSwapper.dbg.json": 1590,
	"./P2PSwapper.sol/P2PSwapper.json": 1591,
	"./P2PSwapper.sol/P2P_WETH.dbg.json": 1592,
	"./P2PSwapper.sol/P2P_WETH.json": 1593,
	"./P2PSwapper.sol/SafeMath.dbg.json": 1594,
	"./P2PSwapper.sol/SafeMath.json": 1595,
	"./P2PSwapper.sol/TransferHelper.dbg.json": 1596,
	"./P2PSwapper.sol/TransferHelper.json": 1597,
	"./P2PSwapperFactory.sol/P2PSwapperFactory.dbg.json": 1598,
	"./P2PSwapperFactory.sol/P2PSwapperFactory.json": 1599,
	"./base/Level-05.sol/Level.dbg.json": 1600,
	"./base/Level-05.sol/Level.json": 1601,
	"./base/Level.sol/Level.dbg.json": 1602,
	"./base/Level.sol/Level.json": 1603
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1525;


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels ^\.\/.*\.json$
// module id = 1525
// module chunks = 0